import React from "react";
import { Box, Card, Button, Typography, alpha, useTheme } from "@mui/material";
import { ExitToApp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../../redux/actions/authAction";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { tracker } from "../../../../analytics";

const LogoutTab = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = useSelector((state) => state.auth?.user?.user);

  const handleLogout = () => {
    dispatch(logout());

    ReactGA.event({
      category: "Settings",
      action: "Logged Out",
      label: `User ID: ${user.id}`,
    });
    tracker.event({
      category: "Settings",
      action: "Logged Out",
      label: `User ID: ${user.id}`,
    });
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          bgcolor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: alpha(theme.palette.error.main, 0.1),
            color: theme.palette.error.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <ExitToApp sx={{ fontSize: 36 }} />
        </Box>

        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            mb: 2,
          }}
        >
          {t("logout")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            textAlign: "center",
            color: theme.palette.text.secondary,
            maxWidth: 500,
          }}
        >
          {t("disconnect_confirmation")}
        </Typography>

        <Button
          variant="contained"
          disableElevation
          startIcon={<ExitToApp />}
          onClick={handleLogout}
          sx={{
            bgcolor: theme.palette.error.main,
            color: "#fff",
            px: { xs: 4, sm: 6 },
            py: 1.5,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
              bgcolor: alpha(theme.palette.error.main, 0.8),
            },
          }}
        >
          {t("logout_ver")}
        </Button>
      </Box>
    </Card>
  );
};

export default LogoutTab;
